import http, { handleHttpError, handleHttpResponse } from '../../services/http'
import { HTTPResponse } from '../../services/http/http.types'
import { IProject, IProjectSlot, ProjectSlotRole } from './projects.types'



export interface ICreateProjectSlotDto extends Omit<IProjectSlot, 'id' | 'roles'> {
    projectId: IProject['id']
}

const createProjectSlot = async (dto: ICreateProjectSlotDto): Promise<HTTPResponse<IProjectSlot>> => {
  return http.post('/nsi/v1/project-slots', dto).then(handleHttpResponse).catch(handleHttpError)
}

const updateProjectSlot = async (
  id: IProjectSlot['id'],
  updates: Partial<ICreateProjectSlotDto>
): Promise<HTTPResponse<IProjectSlot>> => {
  return http
    .patch('/nsi/v1/project-slots/' + id, updates)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const deleteProjectSlot = async (
  id: IProjectSlot['id'],
): Promise<HTTPResponse> => {
  return http
    .delete('/nsi/v1/project-slots/' + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

export interface ICreateProjectSlotRoleDto extends Omit<ProjectSlotRole, 'role' | 'id'> {
  slotId: IProjectSlot['id']
}

const createProjectSlotRole = async (dto: ICreateProjectSlotRoleDto): Promise<HTTPResponse<Omit<ProjectSlotRole, 'role'>>> => {
  return http.post('/nsi/v1/project-slots/user-role', dto).then(handleHttpResponse).catch(handleHttpError)
}

const updateProjectSlotRole = async (
  id: ProjectSlotRole['id'],
  updates: Partial<ICreateProjectSlotRoleDto>
): Promise<HTTPResponse<Omit<ProjectSlotRole, 'role'>>> => {
  return http
    .patch('/nsi/v1/project-slots/user-role/' + id, updates)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const deleteProjectSlotRole = async (
  id: ProjectSlotRole['id'],
): Promise<HTTPResponse> => {
  return http
    .delete('/nsi/v1/project-slots/user-role/' + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}



const projectSlotApi = {
  createProjectSlot,
  updateProjectSlot,
  deleteProjectSlot,
  createProjectSlotRole,
  updateProjectSlotRole,
  deleteProjectSlotRole
}
export default projectSlotApi
